const SearchChdTvQueries: Record<string, string> = {};

SearchChdTvQueries.videosQuery = `
{
  allContentfulVideo(filter: {visible: {eq: true}}) {
    nodes {
      description {
        description
      }
      id
      internal {
        contentDigest
        type
      }
      node_locale
      publishDate
      slug
      thumbnailMediaStandard {
        gatsbyImageData(
          width: 275
          breakpoints: [275, 550, 925]
          sizes: "100vw"
          layout: FULL_WIDTH
        )
      }
      title
      categories {
        name
      }
      videoTags {
        videoTags
      }
    }
  }
}
`;
SearchChdTvQueries.showsQuery = `  
{
  allContentfulShow(filter: {visible: {eq: true}}) {
    nodes {
      id
      internal {
        contentDigest
        type
      }
      node_locale
      slug
      title
      contentful_id
      thumbnailMediaStandard {
        gatsbyImageData(
          width: 275
          breakpoints: [275, 550, 925]
          sizes: "100vw"
          layout: FULL_WIDTH
        )
      }
      description {
        description
      }
      episodes {
        title
        visible
        contentful_id
        description {
          description
        }
        categories {
          name
        }
        videoTags {
          videoTags
        }
        id
        internal {
          contentDigest
          type
        }
        node_locale
        publishDate
        slug
        episodeNumber
        thumbnailMediaStandard {
          gatsbyImageData(
            width: 275
            breakpoints: [275, 550, 925]
            sizes: "100vw"
            layout: FULL_WIDTH
          )
        }
        }
      }
    }
  }
  `;

SearchChdTvQueries.eventsQuery = `
{
  allContentfulEvent(filter: {visible: {eq: true}}) {
    nodes {
      id
      internal {
        contentDigest
        type
      }
      node_locale
      slug
      title
      contentful_id
      description {
        description
      }
      thumbnailMediaStandard {
        gatsbyImageData(
          width: 275
          breakpoints: [275, 550, 925]
          sizes: "100vw"
          layout: FULL_WIDTH
        )
      }
      eventVideos {
        title
        visible
        contentful_id
        description {
          description
        }
        id
        internal {
          contentDigest
          type
        }
        categories {
          name
        }
        videoTags {
          videoTags
        }
        node_locale
        publishDate
        slug
        thumbnailMediaStandard {
          gatsbyImageData(
            width: 275
            breakpoints: [275, 550, 925]
            sizes: "100vw"
            layout: FULL_WIDTH
          )
        }
      }
    }
  }
}
`;

export default SearchChdTvQueries;
